export default "__VITE_ASSET__DtjLzNvq__"